<template lang="html">
  <v-container id="rbi-dashboard" fluid class="h-100 overflow-overlay">
    <div class="h-100 w-100 pa-0" rounded="lg" style="overflow: overlay">
      <v-row class="h-100 ma-0" style="overflow: overlay">
        <v-col :sm="viewerOpened ? 8 : 12" class="h-100 w-100 overflow-x-hidden overflow-y-auto">
          <v-row>
            <v-col cols="12" md="4">
              <v-card
                outlined
                three-line
                :class="[
                  {
                    'active-widget': activeCard == 'frbi',
                  },
                  'h-100 d-flex align-center px-4 rounded-xl late-card widget',
                ]"
                @click="cardClicked('frbi')">
                <v-sheet>
                  <v-img src="/img/late.svg" width="70" height="70" contain />
                </v-sheet>
                <v-card-text class="h-100 pl-3 d-flex flex-column">
                  <v-row>
                    <v-col>
                      <div class="text-h5 font-weight-bold">{{ rfbiCount }}</div>
                      <div class="text-h7">FRBI Analysis Created</div>
                      <div class="text-h7">> 30 Days</div>
                    </v-col>
                    <div class="d-flex justify-center align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click.stop="resetFilter" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card
                outlined
                three-line
                :class="[
                  {
                    'active-widget': activeCard == 'df',
                  },
                  'h-100 d-flex align-center px-4 rounded-xl late-card widget',
                ]"
                @click="cardClicked('df')">
                <v-sheet>
                  <v-img src="/img/exceeded.svg" width="70" height="70" contain />
                </v-sheet>
                <v-card-text class="h-100 pl-3 d-flex flex-column">
                  <v-row>
                    <v-col>
                      <div class="text-h5 font-weight-bold">{{ dfCount }}</div>
                      <div class="text-h7">Target DF Exceeded,</div>
                      <div class="text-h7">Recommendation Not Created</div>
                    </v-col>
                    <div class="d-flex justify-center align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click.stop="resetFilter" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card
                outlined
                three-line
                :class="[
                  {
                    'active-widget': activeCard == 'iow',
                  },
                  'h-100 d-flex align-center px-4 rounded-xl late-card widget',
                ]"
                @click="cardClicked('iow')">
                <v-sheet>
                  <v-img src="/img/limit.svg" width="70" height="70" contain />
                </v-sheet>
                <v-card-text class="h-100 pl-3 d-flex flex-column">
                  <v-row>
                    <v-col>
                      <div class="text-h5 font-weight-bold">{{ iowsCount }}</div>
                      <div class="text-h7">IOW's Excursion of Limits</div>
                      <div class="text-h7"></div>
                    </v-col>
                    <div class="d-flex justify-center align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click.stop="resetFilter" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="pa-2 mb-4">
            <div style="min-height: 380px" rounded="lg" class="w-100">
              <v-row>
                <v-col>
                  <RiskMatrix
                    ref="current"
                    title="Current Risk - September -2024"
                    :data="currentRiskMatrix"
                    :active="filterSelected"
                    key="currentRiskMatrix"
                    :selectedCells.sync="selectedCurrentRiskMatrix">
                  </RiskMatrix>
                </v-col>
                <v-col>
                  <RiskMatrix
                    ref="future"
                    title="Future Risk w/o inspections -2024"
                    :data="futureRiskMatrix"
                    :active="filterSelected"
                    key="futureRiskMatrix"
                    :selectedCells.sync="selectedFutureRiskMatrix">
                  </RiskMatrix>
                </v-col>
                <v-col>
                  <RiskMatrix
                    ref="futureInspections"
                    title="Future Risk w/ inspections - September-2024"
                    :data="futureRiskWithInspectionsMatrix"
                    :active="filterSelected"
                    key="futureInspectionsMatrix"
                    :selectedCells.sync="selectedFutureRiskWithInspectionsMatrix">
                  </RiskMatrix>
                </v-col>
              </v-row>
            </div>
          </v-row>
          <v-sheet class="mt-0 pa-2 rounded-lg">
            <v-row>
              <v-col>
                <DashboardGrid
                  id="rbiDashboardGrid"
                  gridName="rbi"
                  class="flex-grow-1"
                  ref="dashboardGrid"
                  @openViewer="openViewer"
                  :selectedFilters="selectedFilters" 
                  :selectedRowsData.sync="selectedRowsData"
                  :coloredInspections.sync="coloredInspections"/>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
        <v-col v-show="viewerOpened" sm="4" class="pl-0 pb-0 h-100">
          <ViewersSection
            ref="viewersSection"
            :hide360View="true"
            :viewerTab.sync="viewerTab"
            @closeViewersSection="closeInspectViewer" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
  import RiskMatrix from '../components/RiskMatrix.vue';
  import ViewersSection from '../components/ViewersSection.vue';
  import { mapGetters } from 'vuex';
  import DashboardGrid from '../components/DashboardGrid.vue';
  import { ForgeInspection } from '@/scripts/js/forgeModels';
  import { log, warn, error } from '@/utils/debugLogger';

  export default {
    name: 'RBIDashboard',

    data() {
      return {
        viewerTab: '3D View',
        matrixKey: '',
        dimmedCards: {
          current: false,
          future: false,
          futureInspections: false,
        },
      };
    },
    computed: {
      forgeService: {
        get() {
          return this.$store.state.forgeService;
        },
      },
      coloredInspections: {
        get() {
          return this.$store.getters['RBI_DASHBOARD/GET_COLORED_INSPECTIONS'];
        },
        set(value) {
          this.$store.commit('RBI_DASHBOARD/SET_COLORED_INSPECTIONS', value);
        },
      },
      selectedRowsData: {
        get() {
          return this.$store.getters['RBI_DASHBOARD/GET_SELECTED_ROWS_DATA'];
        },
        set(value) {
          this.$store.commit('RBI_DASHBOARD/SET_SELECTED_ROWS_DATA', value);
        },
      },
      viewerOpened: {
        get() {
          return this.$store.getters['RBI_DASHBOARD/GET_VIEWER_OPENED'];
        },
        set(value) {
          this.$store.commit('RBI_DASHBOARD/SET_VIEWER_OPENED', value);
        },
      },
      activeCard: {
        get() {
          return this.$store.getters['RBI_DASHBOARD/GET_ACTIVE_CARD'];
        },
        set(value) {
          this.$store.commit('RBI_DASHBOARD/SET_ACTIVE_CARD', value);
        },
      },
      selectedCurrentRiskMatrix: {
        get() {
          return this.$store.getters['RBI_DASHBOARD/GET_SELECTED_CURRENT_RISK_MATRIX'];
        },
        set(value) {
          this.$store.commit('RBI_DASHBOARD/SET_SELECTED_CURRENT_RISK_MATRIX', value);
        },
      },
      selectedFutureRiskMatrix: {
        get() {
          return this.$store.getters['RBI_DASHBOARD/GET_SELECTED_FUTURE_RISK_MATRIX'];
        },
        set(value) {
          this.$store.commit('RBI_DASHBOARD/SET_SELECTED_FUTURE_RISK_MATRIX', value);
        },
      },
      selectedFutureRiskWithInspectionsMatrix: {
        get() {
          return this.$store.getters['RBI_DASHBOARD/GET_SELECTED_FUTURE_RISK_WITH_INSPECTIONS_MATRIX'];
        },
        set(value) {
          this.$store.commit('RBI_DASHBOARD/SET_SELECTED_FUTURE_RISK_WITH_INSPECTIONS_MATRIX', value);
        },
      },
      selectedFilters() {
        return {
          selectedCard: this.activeCard,
          selectedCurrentRiskMatrix: this.selectedCurrentRiskMatrix,
          selectedFutureRiskMatrix: this.selectedFutureRiskMatrix,
          selectedFutureRiskWithInspectionsMatrix: this.selectedFutureRiskWithInspectionsMatrix,
        };
      },
      filterSelected() {
        return this.selectedCurrentRiskMatrix.length > 0 || this.selectedFutureRiskMatrix.length > 0 || this.selectedFutureRiskWithInspectionsMatrix.length > 0;
      },
      defaultFilters() {
        return this.$store.getters['DASHBOARD_FILTERS/GET_DEFAULT_FILTERS'];
      },
      ...mapGetters('RBI_DASHBOARD', {
        rfbiCount: 'GET_RFBI_COUNT',
        dfCount: 'GET_DF_COUNT',
        iowsCount: 'GET_IOW_COUNT',
        currentRiskMatrix: 'GET_CURRENT_RISK_MATRIX',
        futureRiskMatrix: 'GET_FUTURE_RISK_MATRIX',
        futureRiskWithInspectionsMatrix: 'GET_FUTURE_RISK_W_INSPECTIONS_MATRIX',
      }),
    },
    created() {
      let payload = { facilityId: this.$route.params.id };
      this.$store.dispatch('RBI_DASHBOARD/GET_RFBI_COUNT', payload);
      this.$store.dispatch('RBI_DASHBOARD/GET_DF_COUNT', payload);
      this.$store.dispatch('RBI_DASHBOARD/GET_IOW_COUNT', payload);
      this.$store.dispatch('RBI_DASHBOARD/GET_RISK_MATRIX', payload);
    },
    activated() {
      if (this.viewerOpened) {
        this.openViewer();
      }
    },
    methods: {
      resetMatrices(except = null) {
        if (except != 'current') this.selectedCurrentRiskMatrix = [];
        if (except != 'future') this.selectedFutureRiskMatrix = [];
        if (except != 'futureInspections') this.selectedFutureRiskWithInspectionsMatrix = [];
        this.matrixKey = new Date().getTime();
      },
      cardClicked(selectedCard) {
        this.activeCard = selectedCard;
        this.resetMatrices();
      },
      openViewer() {
        this.viewerOpened = true;
        this.handleViewerChange();
      },
      handleViewerChange() {
        if (this.viewerTab === '3D View') {
          this.handle3dViewer();
        } else if (this.viewerTab === '2D View') {
          this.handle2dViewer();
        }
      },
      handle3dViewer() {
        this.$refs.viewersSection.load3dViewer().then(() => {
          this.$refs.dashboardGrid.isolateSelectedInspection3d();
        });
      },
      handle2dViewer() {
        if (!this.viewerOpened) return;
        
        let selectedInspections = this.$refs.dashboardGrid.selectedColoredInspections;

        if (!Array.isArray(selectedInspections)) selectedInspections = [selectedInspections];

        if (selectedInspections.length === 0) {
          this.$dialog.notify.error('No inspection selected');
          return;
        }

        selectedInspections = selectedInspections.map((o) => {
          if (o instanceof ForgeInspection) {
            return o;
          } else {
            let e = Object.assign(new ForgeInspection(), o);
            e.parseContent();
            return e;
          }
        });

        this.handleIsolateMatchedInspections2d(selectedInspections);
      },
      async handleIsolateMatchedInspections2d(inspections) {
        let points = inspections.map((o) => o?.point).filter((o) => o);

        let levelsSet = new Set(points.map((o) => this.forgeService.getLevelContainsPoint(o)));

        let levels = Array.from(levelsSet).filter((o) => o);

        let level = levels.length == 1 ? levels[0] : this.$store.state.levels[0];

        if (levels.length > 1) {
          error('RBI', 'Multiple levels found', levels);
          this.$dialog.notify.warning('Multiple levels found');
        }

        this.$store.state.selectedLevel = level;

        if (!level?.planUrn) {
          error('RBI', 'Plan URN not found', level);
          this.$dialog.notify.error('Plan URN not found');
          this.$refs.viewersSection.viewerState.isLoading = false;
          return;
        }

        this.$refs.viewersSection.load2dViewer(level.planUrn).then(() => {
          // this.forgeService.zoomToPoints2D(points);
          this.forgeService.getLabels2DExtension().clear3DTags();
          this.forgeService.getLabels2DExtension().createHighlightingTags(inspections);
          this.$refs.viewersSection.viewerState.isLoading = false;
        });
      },
      closeInspectViewer() {
        this.viewerOpened = false;
      },
      resetFilter() {
        this.cardClicked('');
      },
    },
    watch: {
      viewerOpened() {
        this.$emit('viewerOpened', this.viewerOpened);
      },
      viewerTab: {
        handler: function () {
          this.handleViewerChange();
        },
      },
      selectedCurrentRiskMatrix(val) {
        if (val.length) {
          this.selectedFutureRiskMatrix = [];
          this.selectedFutureRiskWithInspectionsMatrix = [];
        }
      },
      selectedFutureRiskMatrix(val) {
        if (val.length) {
          this.selectedCurrentRiskMatrix = [];
          this.selectedFutureRiskWithInspectionsMatrix = [];
        }
      },
      selectedFutureRiskWithInspectionsMatrix(val) {
        if (val.length) {
          this.selectedCurrentRiskMatrix = [];
          this.selectedFutureRiskMatrix = [];
        }
      },
    },
    components: {
      ViewersSection,
      RiskMatrix,
      DashboardGrid,
    },
  };
</script>
<style lang="scss">
  #rbi-dashboard {
    & > .v-sheet {
      border: 1px solid var(--v-light-grey-base);
      background: var(--v-light-grey-base);
    }

    & .late-card {
      border-left: 5px solid #a50002;
    }

    & .exceeded-card {
      border-left: 5px solid #c04f15;
    }

    & .limit-card {
      border-left: 5px solid #a80000;
    }

    .widget {
      cursor: pointer;
    }
    .active-widget {
      background-color: var(--v-bg1-base);
    }
  }
</style>
